<script setup lang="ts">
import {Icon} from '@iconify/vue';
import type {AnalysisResult} from '@/generated';

// Read-only Analyse-Dashboard (Tonart / Taktart / Spielbarkeit + unspielbare Noten). Extrahiert aus
// TranspositionPanel.vue in eine eigenständige, wiederverwendbare Komponente.
const {analysis = null, isAnalyzing = false} = defineProps<{
  analysis?: AnalysisResult | null;
  isAnalyzing?: boolean;
}>();
</script>

<template>
  <div class="flex-auto flex flex-col min-w-0 w-full">
    <!-- Info Dashboard -->
    <div class="flex flex-wrap gap-4 w-full text-sm">
      <!-- Tonart -->
      <div class="basis-1/3 bg-gray-50/50 rounded-xl p-4 border border-gray-100 flex flex-col">
        <span class="flex-1 text-xs text-gray-500 uppercase tracking-wider font-semibold mb-1">Tonart</span>
        <div v-if="isAnalyzing" class="flex-none h-6 w-16 animate-pulse rounded bg-gray-200"/>
        <span v-else class="flex-1 font-bold text-gray-800">{{ analysis?.key || '-' }}</span>
      </div>

      <!-- Taktart -->
      <div class="basis-1/3 bg-gray-50/50 rounded-xl p-4 border border-gray-100">
        <p class="text-xs text-gray-500 uppercase tracking-wider font-semibold mb-1">Taktart</p>
        <div v-if="isAnalyzing" class="h-6 w-12 animate-pulse rounded bg-gray-200"/>
        <p v-else class="text-lg font-bold text-gray-800">{{ analysis?.time_signature || '-' }}</p>
      </div>

      <!-- Spielbarkeit -->
      <div
          class="basis-1/3 bg-gray-50/50 rounded-xl w-12 grow items-center justify-center p-2 border border-gray-100"

      >
        <p class="text-xs text-gray-500 uppercase tracking-wider font-semibold mb-2">Status</p>
        <div v-if="isAnalyzing" class="flex items-center gap-1.5 text-gray-400">
          <Icon icon="fa6-solid:spinner" class="animate-spin"/>
          <span class="text-sm font-medium">Analysiere…</span>
        </div>
        <div
            v-else-if="analysis?.unmappable_count"

            class="flex items-center justify-center text-red-600"
        >
          <Icon icon="fa6-solid:triangle-exclamation" class="mr-1.5"/>
          <span class="font-bold">{{ analysis.unmappable_count }} unspielbar</span>
        </div>
        <div v-else class="flex items-center text-green-600">
          <Icon icon="fa6-solid:check-circle" class="mr-1.5"/>
          <span class="font-bold">Perfekt spielbar</span>
        </div>
      </div>

      <!-- Unspielbare Noten (Note × Häufigkeit) -->
      <div v-if="!isAnalyzing && analysis?.unmappable_count" class="flex flex-auto max-w-full py-4 rounded-xl border border-red-100/50">
        <div class="flex flex-wrap w-full gap-1">
        <span
            v-for="(count, note) in analysis?.unmappable_occurrences" :key="note"
            class="inline-flex items-center px-2.5 py-1 rounded-md bg-white border border-red-100 text-xs text-red-700 shadow-sm"
        >
          <span class="font-bold mr-1">{{ note }}</span>
          <span class="text-red-400">×{{ count }}</span>
        </span>
        </div>
      </div>
    </div>

  </div>
</template>
